<template>
  <div class="filter-settings-container">
    <span class="filter-header">Filter Elements Shown</span>
    <div class="filter-settings-scrollable">
      <field-container title="Zone">
        <div class="mdc-select mdc-select--filled">
          <div
            class="mdc-select__anchor"
            role="button"
            aria-haspopup="listbox"
            aria-expanded="false"
            aria-labelledby="demo-label demo-selected-text"
          >
            <span class="mdc-select__ripple"></span>

            <span class="mdc-select__selected-text-container">
              <span
                id="demo-selected-text"
                class="mdc-select__selected-text"
              ></span>
            </span>
            <span class="mdc-select__dropdown-icon">
              <svg
                class="mdc-select__dropdown-icon-graphic"
                viewBox="7 10 10 5"
                focusable="false"
              >
                <polygon
                  class="mdc-select__dropdown-icon-inactive"
                  stroke="none"
                  fill-rule="evenodd"
                  points="7 10 12 15 17 10"
                ></polygon>
                <polygon
                  class="mdc-select__dropdown-icon-active"
                  stroke="none"
                  fill-rule="evenodd"
                  points="7 15 12 10 17 15"
                ></polygon>
              </svg>
            </span>
          </div>

          <div
            class="mdc-select__menu mdc-menu mdc-menu-surface mdc-menu-surface--fullwidth"
          >
            <ul
              class="mdc-list"
              role="listbox"
              aria-label="Zone picker listbox"
            >
              <li
                v-for="(zone, i) in zones"
                class="mdc-list-item"
                aria-selected="false"
                :data-value="zone.name"
                role="option"
                :key="i"
                :selected="zone.name === settings.zones.selectedZone"
                v-bind:class="{
                  ['mdc-list-item--selected']:
                    zone.name === settings.zones.selectedZone,
                }"
              >
                <span class="mdc-list-item__ripple"></span>
                <span class="mdc-list-item__text">
                  {{ zone.name }}
                </span>
              </li>
            </ul>
          </div>
        </div>
        <mat-switch
          label="Show selected Zones as overlay"
          :active="settings.zones.selectedZonesAsOverlay"
          :onChange="onShowSelectedZoneAsOverlayChange"
        >
        </mat-switch>
      </field-container>
      <field-container title="Site Types">
        <mat-switch
          v-for="(siteType, i) in Object.keys(settings.siteTypes)"
          :key="i"
          :icon="badge[siteType]"
          :label="siteType"
          :active="settings.siteTypes[siteType]"
          :onChange="onSiteTypeFilterChange"
        >
        </mat-switch>
      </field-container>
    </div>
  </div>
</template>

<script>
import FieldContainer from '../../common/field-container';
import MatSwitch from '../../common/mat-switch';
import { MDCSelect } from '@material/select';
import SelectCheckbox from '../../common/select-checkbox';

export default {
  components: {
    FieldContainer,
    MatSwitch,
    SelectCheckbox,
  },

  props: {
    settings: Object,
  },

  computed: {
    badge: () =>
      [
        ['Spray Reminder', 'badge-spray-reminder-active'],
        ['No Spray', 'badge-no-spray-active'],
      ].reduce(
        (acc, [name, fileName]) => ({
          ...acc,
          [name]: require(`@/assets/img/map/${fileName}.svg`),
        }),
        {}
      ),
    zones() {
      return this.$store.state.map.zones;
    },
  },

  methods: {
    onShowSelectedZoneAsOverlayChange(active) {
      this.settings.zones.selectedZonesAsOverlay = active;
    },

    onSiteTypeFilterChange(active, siteType) {
      this.settings.siteTypes[siteType] = active;
    },

    initZones() {
      const $this = this;
      const select = new MDCSelect(document.querySelector('.mdc-select'));
      select.listen('MDCSelect:change', () => {
        if (select !== $this.select) {
          return;
        }
        $this.settings.zones.selectedZone = select.value;
      });
      $this.select = select;
    },
  },

  mounted() {
    this.initZones();
  },

  updated() {
    this.$nextTick(function() {
      this.initZones();
    });
  },
};
</script>

<style lang="scss" scoped>
.md-menu-content-container {
  cursor: pointer;
  & .md-list-item-text {
    padding: 0.25rem 1rem;
  }
}

.filter-settings-container {
  margin-left: 2rem;
  margin-right: 1rem;
  margin-top: 0.25rem;
  overflow: hidden;
  height: 100%;
  .filter-settings-scrollable {
    overflow-y: auto;
    height: 747px;
  }

  & .filter-header {
    font-family: Roboto;
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #25345c;
  }

  & .field-container {
    margin-bottom: -1.75rem;

    & .md-field {
      margin: -2rem 0 1rem;
      &::after,
      &::before {
        background-color: transparent;
      }

      & .md-select {
        overflow: visible;

        & .md-input {
          border: none;
          font-family: Roboto;
          font-size: 11.2px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.71;
          letter-spacing: normal;
          color: rgba(0, 0, 0, 0.87);
        }

        & .md-icon {
          position: relative;
          top: -2px;
          left: 4px;
          width: 35px;
          height: 35px;

          & svg {
            fill: black;
          }
        }
      }
    }
  }
}
</style>
